import type { LOAN_REQUEST_USAGE } from 'cpool-constants';
import { LOAN_REQUEST_OFFER_SOURCES } from 'cpool-constants';

import type { AcceptedOffer } from '../../types';

type LeadFinancingPurpose = {
    finanzbedarf: { finanzierungszweck: LOAN_REQUEST_USAGE | null };
};

// Only manual offers carry their own financing purpose; every other source falls back to the lead's.
export const getOfferFinancingPurpose = (
    acceptedOffer: AcceptedOffer,
    lead: LeadFinancingPurpose | null | undefined,
): LOAN_REQUEST_USAGE | null => {
    if (acceptedOffer.source === LOAN_REQUEST_OFFER_SOURCES.MANUAL) return acceptedOffer.financingPurpose ?? null;

    return lead?.finanzbedarf.finanzierungszweck ?? null;
};
